import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatStepperModule} from '@angular/material/stepper';

@NgModule
({
    imports: [MatChipsModule , MatExpansionModule, MatButtonModule, MatListModule, MatRippleModule, MatToolbarModule, MatIconModule, MatProgressSpinnerModule, MatDialogModule, MatCardModule, MatDividerModule, MatInputModule, MatRadioModule, MatBadgeModule, MatSnackBarModule, MatGridListModule, MatStepperModule],
    exports: [MatChipsModule , MatExpansionModule, MatButtonModule, MatListModule, MatRippleModule, MatToolbarModule, MatIconModule, MatProgressSpinnerModule, MatDialogModule, MatCardModule, MatDividerModule, MatInputModule, MatRadioModule, MatBadgeModule, MatSnackBarModule, MatGridListModule, MatStepperModule]
})

export class MaterialModule {}